import RowCell from 'components/Grids/DataGrid/Cells/RowCell';
import { appReactMemo } from 'hocs';
import { getFormattedDate } from 'utils/common';

import { TReportRowCellProps } from './types';

interface IDateCellProps extends TReportRowCellProps {
  date: string;
}

const DateCell = ({ date, ...rest }: IDateCellProps) => (
  <RowCell {...rest}>{getFormattedDate(date)}</RowCell>
);

export default appReactMemo(DateCell);
